/* global G */
import ui from 'lib/hook/ui/update'
import recall from 'app/_shared/hook/component/recall'
import quickActions from 'app/_shared/hook/appbar/quickActions'

const _listHooks = {
  before: [
    recall,
  ],
  after: [
    quickActions,
    ui,
  ],
}

const _editHooks = {
  before: [],
  after: [
    ui,
  ],
}

const hooks = {
  [G.ACTIONS]: {
    alerts: _listHooks,
    messages: _listHooks,
    editAlert: _editHooks,
  },
}

export default hooks
